module.exports = __webpack_public_path__ + "img/horizontal_6_3_3016.56bc0a47.png";